

import React, { useEffect, useMemo, useRef, useState } from 'react';
//  CODE FOR ONE PAGE
import LayerPanelPage from "./LayerPanelPage";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import "@arcgis/core/assets/esri/themes/light/main.css";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import html2pdf from "html2pdf.js";
import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";
//Graphic show on map
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import LayerControlPanel from '../../componets/LayerControlPanel';
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Point from "@arcgis/core/geometry/Point";
import Polyline from "@arcgis/core/geometry/Polyline";
import Polygon from "@arcgis/core/geometry/Polygon";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";
import { set } from 'lodash';



const baseURL = "https://urbangis.mp.gov.in/server"
// Layer definitions
const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

const layers = {

  WATER_RWPM: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer",
    sublayerId: 5
  },
  WATER_CWPM: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer",
    sublayerId: 6
  },
  WATER_Distribution_Network: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/ws_intersect_poi/MapServer",
    sublayerId: 1
  },

};



const layersSpc = {
  property: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer",
    sublayerId: 14
  },

  SEWER_Line: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer",
    sublayerId: 5
  },
  STORMWater: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/stormwater_project_data/MapServer",
    sublayerId: 1
  },
};


//  layer End 


function QueryAnalysis({ isWidth, isScreenSize, isByDefaultActive }) {

  const [tabLocation, setTabLocation] = useState(false);
  const { isTheme, isBufferWidth, isToolHeight, currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
  const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
  const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
  const dispatch = useDispatch()
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districtCode, setDistrictCode] = useState("");
  const authData = useSelector(state => state.authToken.authData);

  const [ulbs, setUlbs] = useState([]);
  const [selectedUlb, setSelectedUlb] = useState("");
  const [ulbCode, setUlbCode] = useState("");
  const [refactive, setRefactive] = useState("0");
  const [wards, setWards] = useState([]);
  const [selectedWard, setSelectedWard] = useState("");
  const [wardCode, setWardCode] = useState("");
  const [active, setActive] = useState("total");
  const [activeSelect, setActiveSelect] = useState("area");

  const [isDrag, setIsDrag] = useState(false);
  const [isTableView, setIsTableView] = useState(false);

  // State for PrimeReact DataTable
  const waterLayerRef = useRef(null);
  const sewerLayerRef = useRef(null);
  //   NEW TOOLS 2025
  // 30 DEC 2025 
  const layerRef = useRef(null);
  const [map, setMap] = useState(null);
  const mapDiv = useRef(null);
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  // TABLE DATA
  const [totalULB, setTotalULB] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [tableData, setTableData] = React.useState([]);
  const [tableData2, setTableData2] = React.useState([]);
  const [div1, setDiv1] = useState(false);
  const [div2, setDiv2] = useState(false);
  const [openDiv, setOpenDiv] = useState("div1");

  const [loading, setLoading] = React.useState(false);
  const [Attributes_URL, setAttributes_URL] = useState([]);
  const [Spatial_URL, setSpatial_URL] = React.useState(false);

  const [Attributes_URLQuery, setAttributes_URLQuery] = useState([]);
  const [Spatial_URLQuery, setSpatial_URLQuery] = React.useState(false);

  //  DATA
  //  NEW STATE 


  const buildFilter = (dist_cd, ulb_cd, wardno) => {


    const conditions = [];
    if (dist_cd) conditions.push(`dist_cd = '${dist_cd}'`);
    if (ulb_cd) conditions.push(`ulb_cd = '${ulb_cd}'`);
    if (wardno) conditions.push(`wardno = '${wardno}'`);
    return conditions.length > 0 ? conditions.join(" AND ") : "1=1";
  };
  const [view, setView] = useState(null);




  useEffect(() => {

    if (!mapDiv.current) return;

    const mapInstance = new Map({
      basemap: "topo-vector"  // Use your desired basemap
    });

    const mapView = new MapView({
      container: mapDiv.current,  // The div where the map will render
      map: mapInstance,
      center: [77.4126, 23.2599],
      zoom: 6,
      ui: { components: ["attribution"] }
    });

    // Optionally, add a default layer
    const baseLayer = new MapImageLayer({
      url: mainLayerUrl,
      sublayers: []  // No initial sublayers
    });
    mapInstance.add(baseLayer);
    layerRef.current = baseLayer;

    setMap(mapInstance);    // Set the map reference
    setView(mapView);
    //  AdminLayer(0);    // Set the view reference


    // MAP LAYER LIST  Widget 

    mapView.ui.add(new Home({ view: mapView }), "top-left");
    mapView.ui.add(new Zoom({ view: mapView }), "top-left");
    mapView.ui.add(new Expand({ view: mapView, content: new BasemapGallery({ view: mapView }) }), "top-left");
    mapView.ui.add(new Locate({ view: mapView, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-left");
    mapView.ui.add(new ScaleBar({ view: mapView }), "bottom-right");

    mapView.when(() => {
      const printWidget = new Print({
        view: mapView,
        printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
      });

      const expandPrint = new Expand({
        view: mapView,
        content: printWidget
      });

      mapView.ui.add(expandPrint, "top-left");


    });




    return () => mapView.destroy();


    // end useEffect
  }, []);

  // end useEffect



  // 18DEC  code for map div load

  useEffect(() => {
    const handleResize = () => {
      setIsScreenSize1(window.innerWidth <= 991)
    };
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])


  const handleTabClick = (key, wardNo, distCd) => {
    if (!view) return;

    // Clear previous graphics & layer
    view.graphics.removeAll();
    if (layerRef.current) {
      view.map.remove(layerRef.current);
    }

    // Admin Layer (always added)
    const adminLayer = new MapImageLayer({
      url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer",
      sublayers: [
        { id: 1, visible: true },
        { id: 3, visible: true }
      ]
    });

    // ✅ Build dynamic filter
    let filterExpr = "1=1";

    if (distCd) {
      filterExpr += ` AND dist_cd = '${distCd}'`;
    }

    if (key) {
      filterExpr += ` AND ulb_cd = '${key}'`;
    }

    if (wardNo) {
      filterExpr += ` AND wardno = '${wardNo}'`;
    }

    // Intersection Layer
    const ws_intersect_poiLayer = new MapImageLayer({
      url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/ws_intersect_poi/MapServer",
      sublayers: [
        {
          id: 1,
          title: "IntersectionPoint",
          visible: true,
          definitionExpression: filterExpr
        }
      ]
    });

    // Add layers to map
    view.map.add(adminLayer);
    view.map.add(ws_intersect_poiLayer);

    // Keep reference for later removal
    layerRef.current = ws_intersect_poiLayer;
  };




  const handleTabClickForFeature = async (ulbKey, wardNo, distCd) => {
    try {
      const featureLayer = new FeatureLayer({
        url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/ws_intersect_poi/FeatureServer/1",
        outFields: ["*"]
      });

      await featureLayer.load();

      const query = featureLayer.createQuery();

      // ✅ Build dynamic filter
      let whereClause = "1=1";

      if (distCd) {
        whereClause += ` AND dist_cd = '${distCd}'`;
      }

      if (ulbKey) {
        whereClause += ` AND ulb_cd = '${ulbKey}'`;
      }

      if (wardNo) {
        whereClause += ` AND wardno = '${wardNo}'`;
      }

      query.where = whereClause;

      query.groupByFieldsForStatistics = [
        "dist_cd",
        "dist_nm",
        "ulb_cd",
        "ulb_nm"
      ];

      query.outStatistics = [
        {
          statisticType: "count",
          onStatisticField: "ulb_cd",
          outStatisticFieldName: "ulb_count"
        }
      ];

      query.returnGeometry = false;

      const result = await featureLayer.queryFeatures(query);

      const groupedData = result.features.map(f => f.attributes);

      // Totals
      const totalULB = groupedData.length;
      const totalCount = groupedData.reduce(
        (sum, row) => sum + (row.ulb_count || 0),
        0
      );

      setTableData(groupedData);
      setTotalULB(totalULB);
      setTotalCount(totalCount);

      //setTableData2("");

    } catch (err) {
      console.error("Grouped Query Error:", err);
    }
  };

  const handleQuerySubmit = async (ulbKey, wardNo, distCd) => {
    try {
      const featureLayer = new FeatureLayer({
        url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/ws_intersect_poi/FeatureServer/1"
      });
      setOpenDiv("div2");
      await featureLayer.load();

      const query = featureLayer.createQuery();

      // ✅ Dynamic WHERE clause
      let whereClause = "1=1";

      if (distCd) whereClause += ` AND dist_cd = '${distCd}'`;
      if (ulbKey) whereClause += ` AND ulb_cd = '${ulbKey}'`;
      if (wardNo) whereClause += ` AND wardno = '${wardNo}'`;

      query.where = whereClause;
      //  alert(whereClause);

      // ✅ Only required columns
      query.outFields = [
        "dist_cd",
        "dist_nm",
        "ulb_cd",
        "ulb_nm",
        "wardname",
        "wardno",
        "lat",
        "lng"
      ];

      query.returnGeometry = false; // lat/lng already available


      const result = await featureLayer.queryFeatures(query);

      // ✅ Clean table data
      const tableData2 = result.features.map(f => ({
        dist_cd: f.attributes.dist_cd,
        dist_nm: f.attributes.dist_nm,
        ulb_cd: f.attributes.ulb_cd,
        ulb_nm: f.attributes.ulb_nm,
        wardname: f.attributes.wardname,
        wardno: f.attributes.wardno,
        lat: f.attributes.lat,
        lng: f.attributes.lng,
      }));

      setTableData2(tableData2);
      //setTableData("");

    } catch (err) {
      console.error("Query Error:", err);
    }
  };



  const downloadPDF = () => {
    const element = document.getElementById("pdfTable");

    const options = {
      margin: [0.5, 0.5, 0.5, 0.5], // top, left, bottom, right
      filename: "ULB_Report.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 1.5, scrollY: -window.scrollY }, // prevents cutting off content
      // jsPDF: { unit: "in", format: "a4", orientation: "landscape" }, 
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ['css', 'legacy'] } // allows automatic page breaks for long tables
    };

    html2pdf().set(options).from(element).save();
  };

  const downloadPDFDetails = () => {
    const element = document.getElementById("tblDetails");

    const options = {
      margin: [0.5, 0.5, 0.5, 0.5], // top, left, bottom, right
      filename: "ULB_Report_Details.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 1.5, scrollY: -window.scrollY }, // prevents cutting off content
      // jsPDF: { unit: "in", format: "a4", orientation: "landscape" }, 
      jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      pagebreak: { mode: ['css', 'legacy'] } // allows automatic page breaks for long tables
    };

    html2pdf().set(options).from(element).save();
  };
  // QUERY SUBMIT

  //code for toggle

  const toggleWaterLayer = async (isChecked) => {
    if (isChecked) {
      if (!waterLayerRef.current) {
        const layer = new MapImageLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer",
          sublayers: [
            {
              id: 7,
              visible: true
            }
          ]
        });

        waterLayerRef.current = layer;
        map.add(layer);
      } else {
        waterLayerRef.current.visible = true;
      }
    } else {
      if (waterLayerRef.current) {
        waterLayerRef.current.visible = false;
      }
    }
  };
  const toggleSewerLayer = async (isChecked) => {
    if (isChecked) {
      if (!sewerLayerRef.current) {
        const layer = new MapImageLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer",
          sublayers: [
            {
              id: 5,
              visible: true
            }
          ]
        });

        sewerLayerRef.current = layer;
        map.add(layer);
      } else {
        sewerLayerRef.current.visible = true;
      }
    } else {
      if (sewerLayerRef.current) {
        sewerLayerRef.current.visible = false;
      }
    }
  };

  // end code 
  // ----------------------
  // Fetch features from URL
  // ----------------------



  // code for   Load District ULB 
  useEffect(() => {


    const loadDistricts = async () => {

      const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson`;

      //alert(url);
      try {
        const response = await fetch(url);
        const data = await response.json();

        if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
          const userDistrict = [{
            districtName: authData.DistrictName,
            districtCode: authData.DistrictCode,
          }];
          setDistricts(userDistrict);
          setDistrictCode(authData.DistrictCode);
          setSelectedDistrict(authData.DistrictName);
          await loadUlbs(authData.DistrictCode);
        } else {
          const formatted = data.features.map(f => ({
            districtName: f.properties.districtname,
            districtCode: f.properties.dist_cd,
          }));
          setDistricts(formatted);
        }
      } catch (err) {
        console.error("Error loading districts:", err);
      }
    };


    if (!view) return;

    handleTabClick(ulbCode, wardCode, districtCode);
    handleTabClickForFeature(ulbCode, wardCode, districtCode);

    if (selectedWard && wardCode && ulbCode) {
      zoomToWard(wardCode, ulbCode);
      handleQuerySubmit(ulbCode, wardCode, districtCode);
    } else if (selectedUlb && ulbCode) {
      zoomToUlb(selectedUlb);
    } else if (selectedDistrict && districtCode) {
      zoomToDistrict(selectedDistrict);

    }



    loadDistricts();
  }, [selectedDistrict, selectedUlb, selectedWard, districtCode, ulbCode, wardCode, authData, view]);

  // CODE FOR COMMON

  const zoomToDistrict = async (districtName) => {
    const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/3')}` });
    const query = new Query({ where: `districtname = '${districtName}'`, returnGeometry: true });
    try {
      const { features } = await layer.queryFeatures(query);
      if (features.length) {
        const graphic = new Graphic({
          geometry: features[0].geometry,
          symbol: {
            type: "simple-fill",
            color: [0, 0, 255, 0.0],
            outline: { color: [0, 0, 255], width: 2 }
          }
        });
        view.graphics.add(graphic);
        view.goTo(features[0].geometry.extent.expand(1.0));
      }
    } catch (error) {
      console.error("Error zooming to district:", error);
    }
  };

  const zoomToUlb = async (ulbName) => {
    const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/94')}` });
    const query = new Query({ where: `ulbname = '${ulbName}'`, returnGeometry: true });

    try {
      const { features } = await layer.queryFeatures(query);
      if (features.length) {
        const graphic = new Graphic({
          geometry: features[0].geometry,
          symbol: {
            type: "simple-fill",
            color: [0, 0, 255, 0.0],
            outline: { color: [0, 0, 255], width: 2 }
          }
        });
        view.graphics.add(graphic);
        view.goTo(features[0].geometry.extent.expand(1.0));
      }
    } catch (error) {
      console.error("Error zooming to ULB:", error);
    }
  };

  const zoomToWard = async (wardCode, ulbCode) => {
    const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/95')}` });
    const query = new Query({ where: `wardno = '${wardCode}' AND ulb_cd = '${ulbCode}'`, returnGeometry: true });

    try {
      const { features } = await layer.queryFeatures(query);
      if (features.length) {
        const graphic = new Graphic({
          geometry: features[0].geometry,
          symbol: {
            type: "simple-fill",
            color: [0, 0, 255, 0.0],
            outline: { color: [0, 0, 255], width: 2 }
          }
        });
        view.graphics.add(graphic);
        view.goTo(features[0].geometry.extent.expand(1.5));
      }
    } catch (error) {
      console.error("Error zooming to ward:", error);
    }
  };




  const loadUlbs = async (dist_cd) => {
    const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/94/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=ulbname,ulb_cd&returnDistinctValues=true&f=geojson`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      // 🔹 If logged-in user is normal User → auto ULB
      if (authData?.UserType === "User") {
        const formattedUlbs = [{
          ulbName: authData?.UlbName,
          ulbCode: authData?.Ulb_Code,
        }];

        setUlbs(formattedUlbs);

        // auto select
        setUlbCode(authData?.Ulb_Code);
        setSelectedUlb(authData?.UlbName);

        await loadWards(authData?.Ulb_Code);
        //zoomToFeatureTow(authData?.UlbName, "name", "5");
      }
      // 🔹 District / Admin users
      else if (data?.features) {
        const formattedUlbs = data.features.map(f => ({
          ulbName: f.properties.ulbname,
          ulbCode: f.properties.ulb_cd,
        }));

        setUlbs(formattedUlbs);
      }

    } catch (error) {
      console.error("Error fetching ULBs:", error);
    }
  };

  const loadWards = async (ulb_cd) => {
    const wardLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/95/query";
    const wardQuery = `where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;

    try {
      const wardResponse = await fetch(`${wardLayerUrl}?${wardQuery}`);
      const uploadedWardData = await wardResponse.json();

      if (uploadedWardData.features) {
        const formattedWards = uploadedWardData.features.map((f) => ({
          wardName: f.properties.wardno + "-" + f.properties.wardname,
          wardCode: f.properties.wardno
        }));

        setWards(formattedWards);
        setWardCode("");
        setSelectedWard("");
      }
    } catch (error) {
      console.log("Error fetching wards:", error);
    }
  };


  const handleDistrictChange = async (selectedOption) => {
    if (!selectedOption) {
      handleRefresh();
      return;
    }
    const district = districts.find(d => d.districtCode === selectedOption.value);
    if (district) {
      setDistrictCode(district.districtCode);
      setSelectedDistrict(district.districtName);
      setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
      await loadUlbs(district.districtCode);
      // fetchAndZoomPropertyChanges({ dist_cd: district.districtCode });

    }
  };

  const handleUlbChange = async (selectedOption) => {
    if (!selectedOption) {
      setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");

      // fetchAndZoomPropertyChanges({ dist_cd: districtCode }); // Refetch for the district
      return;
    }
    const ulb = ulbs.find(u => u.ulbCode === selectedOption.value);
    if (ulb) {
      setUlbCode(ulb.ulbCode); setSelectedUlb(ulb.ulbName); setWardCode(""); setSelectedWard("");
      await loadWards(ulb.ulbCode);
      // fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulb.ulbCode });

    }
  };

  const handleWardChange = async (selectedOption) => {
    if (!selectedOption) {
      setWardCode(""); setSelectedWard("");
      //  fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode }); // Refetch for the ULB
      return;
    }
    const ward = wards.find(w => w.wardCode === selectedOption.value);
    if (ward) {
      setWardCode(ward.wardCode); setSelectedWard(ward.wardName);
      // alert(ward.wardCode);
      setTableData2("");
      handleQuerySubmit(ulbCode, wardCode, districtCode);

      //  fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: ward.wardCode });
    }
  };





  const wardOptions = [...wards]
    .sort((a, b) => a.wardName.localeCompare(b.wardName))
    .map(w => ({
      value: w.wardCode,
      label: w.wardName,
    }));
  const handleRefresh = async () => {
    // Reset Map
    view.graphics.removeAll(); // Clear any highlights

    // Go to the initial extent or center
    view.goTo({
      center: [77.4126, 23.2599],
      zoom: 6,
      ui: { components: ["attribution"] }
    });

    // Reset all filter states
    setSelectedDistrict("");
    setDistrictCode("");
    setSelectedUlb("");
    setUlbCode("");
    setSelectedWard("");
    setWardCode("");
    setTableData("");
    //setTableData2("");

    // Reset dropdown options
    setUlbs([]);
    setWards([]);

    // Dispatch reset actions
    dispatch(setIsDist(""));
    dispatch(setIsUlb(""));
    dispatch(setIsWard(""));


    // Reset the map view to initial state

  };

  //   code for Common
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
      borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
      "&:hover": {
        borderColor: "#ccc",
      },
      fontSize: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#d1ede9"
        : state.isFocused
          ? "#d1ede9"
          : "#FFFFFF",
      color: "#000",
      fontSize: "12px",
      padding: "10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "12px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#000",
      fontSize: "12px",
    }),
    input: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "12px",
    }),
  };

  const styles = {
    container: {
      width: "100%",
      marginTop: "10px",
      marginLeft: "10px",
      background: "#ffffff",
      padding: "12px",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      fontFamily: "Arial, sans-serif"
    },
    heading: {
      marginBottom: "10px",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#333"
    },
    loading: {
      color: "#666",
      fontSize: "14px"
    },
    tableWrapper: {
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      border: "1px solid #ddd",
      borderRadius: "6px"
    },

    table: {
      width: "100%",
      height: "200px",
      borderCollapse: "collapse",
      fontFamily: "Arial, sans-serif"
    },
    th: {
      border: "1px solid #333",
      padding: "8px",
      textAlign: "center",
      backgroundColor: "#f2f2f2",
      fontWeight: "bold"
    },
    td: {
      border: "1px solid #333",
      padding: "8px",
      textAlign: "center"
    },
    evenRow: {
      backgroundColor: "#fafafa"
    },
    hoverRow: {
      backgroundColor: "#e6f2ff"
    }


  };
  const handleTableView = () => {
    setIsTableView(!isTableView)
  }


  // code for map 
  const handleDrag = () => {
    setIsDrag(!isDrag)
  }
  const calculatedHeight = useMemo(() => {
    const hasFeatureTableData = setFeatureTable?.length > 0;
    if (isWidth && isByDefaultActive) {
      return "calc(100vh - 78px)"; // Adjust height as needed
    }
    if (isScreenSize1) {
      return tabLocation === "/user-chatbot" ? "calc(100vh - 200px)" : "calc(80vh - 78px)";
    }
    if (tabLocation) {
      return "calc(100vh - 78px)";
    }
    if (isDrag) {
      return "0px";
    }
    if (isWidth) {
      return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
    }
    if (isWidth) {
      return "calc(100vh - 78px)"
    }
    if (!isWidth && hasFeatureTableData) {
      return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
    }
    if (!isWidth && hasFeatureTableData && isByDefaultActive) {
      return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
    }
    if (isBufferWidth && isToolHeight) {
      // return "calc(100vh - 110px)"
      return "calc(100vh - 330px)"
    }
    if (isToolHeight) {
      return "calc(100vh - 330px)"
    }

    return "calc(100vh - 425px)";
  }, [tabLocation, isDrag, isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight]);

  const handleToggleBufferWidth = () => {
    // dispatch(setIsBufferWidth(!isBufferWidth));
    console.log("left")
  };
  const handleToggleBufferLeft = () => {
    // dispatch(setIsSidebar(!isSideBar));
  };
  // CARD CSS
  // ===== Styles =====
  const tdLabel = {
    padding: "10px",
    fontWeight: "600",
    color: "#333",
    borderBottom: "1px solid #e5e5e5",
    width: "45%",
  };

  const tdValue = {
    padding: "10px",
    color: "#555",
    borderBottom: "1px solid #e5e5e5",
  };

  const cardStyle = {
    backgroundColor: "#f2f2f2",
    border: "2px solid #9a9a9a",
    borderRadius: "6px",
    padding: "22px 18px",
    width: "340px",
    position: "relative",
    boxShadow: "0 8px 18px rgba(0,0,0,0.35)",
    fontFamily: "Segoe UI, sans-serif"
  };

  const cardHeader = {
    background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
    borderRadius: "4px", overflow: "auto",
    fontSize: "18px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "14px",
    color: "#333"
  };

  const cardRow = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8px"
  };

  const labelStyle = {
    fontWeight: "600",
    color: "#555"
  };

  const valueStyle = {
    color: "#000"
  };

  const divider = {
    height: "1px",
    backgroundColor: "#aaa",
    margin: "14px 0"
  };

  const countBox = {
    textAlign: "center",
    padding: "10px",
    background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
    borderRadius: "4px", overflow: "auto",

    border: "1px solid #aaa",
    boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)"
  };

  const countLabel = {
    fontSize: "14px",
    color: "#444"
  };

  const countValue = {
    fontSize: "26px",
    fontWeight: "700",
    color: "#000"
  };

  const screwStyle = {
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    background: "radial-gradient(circle at 30% 30%, #eee, #777)",
    border: "1px solid #555",
    position: "absolute",
    boxShadow:
      "inset 1px 1px 2px rgba(255,255,255,0.6), inset -1px -1px 2px rgba(0,0,0,0.6)"
  };

  const screwLine = {
    position: "absolute",
    width: "8px",
    height: "2px",
    backgroundColor: "#444",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(25deg)"
  };

  // Card CSS

  const [activeSelect2, setActiveSelect2] = useState("area1"); // default active tab

  const tabStyle = (tab) => ({
    backgroundColor: "#066054",
    color: "#fff",
    border: "1px solid #ccc",
    padding: "6px 12px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    borderRadius: "4px"
  });


  return (
    <>

      <div className={isTableView ? 'd-none' : ''}
        style={{ height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)' }}>
        <div className='row h-100' >
          <div className={isBufferWidth ? 'col-md-12 p-0' : "col-md-9 p-0"}>
            <div ref={mapDiv}
              style={{
                width: "100%",
                // Reserve the table's 230px plus the header and visible Tools.
                height: isToolHeight ? 'calc(100vh - 339px)' : 'calc(100vh - 435px)',
                overflow: "hidden",
              }}
            >
            </div>

            <div style={{
              borderRadius: "4px", overflow: "auto",
              marginLeft: "10px", height: "230px",
              marginRight: "10px"
            }}>

              <button style={{
                float: "right",
                borderRadius: "4px", overflow: "auto",
              }} onClick={downloadPDF}>Download Total ULB </button>

              {selectedWard && (
                <button style={{
                  float: "right",
                  borderRadius: "4px", overflow: "auto",
                }} onClick={downloadPDFDetails}>Download Details PDF</button>
              )}



              <div style={{ width: "300px" }} className="tabs-container d-flex justify-content-between mt-3">
                <button
                  style={tabStyle("div1")}
                  onClick={() => {
                    setOpenDiv("div1")
                    handleTabClickForFeature();
                  }}
                >
                  Total ULB
                </button>

              </div>



              <div style={styles.container}>
                {loading && <p style={styles.loading}>Loading...</p>}
                {!loading && tableData.length > 0 && (
                  <>
                    {openDiv === "div1" && (
                      <div id="pdfTable" style={{ overflow: "auto", }}>
                        {tableData && tableData.length > 0 ? (
                          <table style={styles.table}>
                            <thead>
                              <tr>
                                <th style={styles.th} colSpan={9}>
                                  <div
                                    style={{
                                      border: "1px solid #dcdcdc",
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                      background: "#fff",
                                      width: "100%",
                                    }}
                                  >
                                    {/* Header */}
                                    <div
                                      style={{
                                        background: "linear-gradient(90deg, #8faeb1, #8eccca)",
                                        padding: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <h6 style={{ color: "#100909", margin: 0, fontWeight: "600" }}>
                                        Intersection of  Water Distribution Network &
                                        Sewer Line Network
                                      </h6>


                                    </div>

                                    {/* Table */}
                                    <center>
                                      <table
                                        style={{
                                          width: "100%",
                                          borderCollapse: "collapse",
                                          textAlign: "center",
                                        }}
                                      >
                                        <tbody>
                                          <tr>
                                            <td>
                                              <b style={{ color: "#100909", margin: 0, fontWeight: "600" }}>
                                                <div>Madhya Pradesh</div>
                                                <div>ULB Wise Summary</div>
                                              </b>

                                            </td>
                                          </tr>

                                          <tr>
                                            <td>
                                              <span>Total ULB: {totalULB}----</span>
                                              <span>Intersection Points : {totalCount}</span>
                                            </td>
                                          </tr>

                                        </tbody>
                                      </table>

                                    </center>
                                  </div>

                                </th>
                              </tr>
                            </thead>
                            <thead>
                              <tr>
                                <th style={styles.th}>S.No.</th>
                                <th style={styles.th}>District Name</th>
                                <th style={styles.th}>ULB Code</th>
                                <th style={styles.th}>ULB Name</th>
                                <th style={styles.th}>Count</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tableData.map((row, index) => (
                                <tr
                                  key={index}
                                  style={index % 2 === 0 ? styles.evenRow : {}}
                                >
                                  <td style={styles.td}>{index + 1}</td>
                                  <td style={styles.td}>{row.dist_nm}</td>
                                  <td style={styles.td}>{row.ulb_cd}</td>
                                  <td style={styles.td}>{row.ulb_nm}</td>
                                  <td style={styles.td}>{row.ulb_count}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>


                        ) : (
                          <div style={{ padding: "10px", textAlign: "center" }}>

                          </div>
                        )}



                        {/* ✅ Bottom Summary */}
                        <div style={{
                          marginTop: "10px",
                          fontWeight: "bold",
                          textAlign: "right"
                        }}>
                          <span>Total ULB: {totalULB}</span>
                          &nbsp; | &nbsp;
                          <span>Total Count: {totalCount}</span>
                        </div>
                      </div>
                    )}


                    {openDiv === "div2" && (
                      <div id="tblDetails" style={{ overflow: "auto", }}>

                        {tableData2 && tableData2.length > 0 ? (
                          <table style={styles.table}>
                            <thead>
                              <tr>
                                <th style={styles.th} colSpan={9}>
                                  <center>
                                    <div
                                      style={{
                                        border: "1px solid #dcdcdc",
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        background: "#fff",
                                        width: "100%",
                                      }}
                                    >
                                      {/* Header */}
                                      {/* <div
                                        style={{
                                          background: "linear-gradient(90deg, #a7ced1, #5cd8d4)",
                                          padding: "10px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <h6 style={{ color: "#100909", margin: 0, fontWeight: "600" }}>
                                          Intersection of  Water Distribution Network &
                                          Sewer Line Network
                                        </h6>

                                        <h6 style={{ color: "#100909", margin: 0, fontWeight: "600" }}>
                                          Details  Summary
                                        </h6>

                                      </div> */}
                                      <div
                                        style={{
                                          background: "linear-gradient(90deg, #8faeb1, #8eccca)",
                                          padding: "10px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <h5 style={{ color: "#100909", margin: 0, fontWeight: "600" }}>
                                          Intersection of  Water Distribution Network &
                                          Sewer Line Network
                                        </h5>
                                        <h6>
                                          Details  Summary
                                        </h6>

                                      </div>
                                      {/* Table */}
                                      {(selectedDistrict || selectedUlb || selectedWard) && (
                                        <table
                                          style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                          }}
                                        >
                                          <tbody>
                                            {selectedDistrict && (
                                              <tr>
                                                <td style={tdLabel}>District Name</td>
                                                <td style={tdValue}>{selectedDistrict}</td>
                                              </tr>
                                            )}

                                            {selectedUlb && (
                                              <tr>
                                                <td style={tdLabel}>ULB Name</td>
                                                <td style={tdValue}>{selectedUlb}</td>
                                              </tr>
                                            )}

                                            {selectedWard && (
                                              <>
                                                <tr>
                                                  <td style={tdLabel}>Ward Name</td>
                                                  <td style={tdValue}>{selectedWard}</td>
                                                </tr>
                                                <tr>
                                                  <td style={tdLabel}>Intersection Points</td>
                                                  <td style={{ ...tdValue, fontWeight: "700" }}>
                                                    {totalCount}
                                                  </td>
                                                </tr>
                                              </>
                                            )}
                                          </tbody>
                                        </table>
                                      )}
                                    </div>

                                  </center>
                                </th>
                              </tr>
                            </thead>
                            <thead>
                              <tr>
                                <th style={styles.th}>S.No.</th>
                                <th style={styles.th}>District Code</th>
                                <th style={styles.th}>District Name</th>
                                <th style={styles.th}>ULB Code</th>
                                <th style={styles.th}>ULB Name</th>
                                <th style={styles.th}>Ward Name</th>
                                <th style={styles.th}>Ward No</th>
                                <th style={styles.th}>Latitude</th>
                                <th style={styles.th}>Longitude</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tableData2.map((row, index) => (
                                <tr key={index}>
                                  <td style={styles.td}>{index + 1}</td>
                                  <td style={styles.td}>{row.dist_cd}</td>
                                  <td style={styles.td}>{row.dist_nm}</td>
                                  <td style={styles.td}>{row.ulb_cd}</td>
                                  <td style={styles.td}>{row.ulb_nm}</td>
                                  <td style={styles.td}>{row.wardname}</td>
                                  <td style={styles.td}>{row.wardno}</td>
                                  <td style={styles.td}>{row.lat}</td>
                                  <td style={styles.td}>{row.lng}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <div style={{ padding: "10px", textAlign: "center" }}>

                          </div>
                        )}


                      </div>
                    )}


                  </>
                )}
              </div>


            </div>
          </div>
          {!isBufferWidth && (
            <div className='col-md-3 p-0' style={{ maxHeight: '100%', overflowY: 'auto', minWidth: 0 }}>
              <div className='px-2'>
                <div className='tooltitlediv linear-gradian-bg d-flex justify-content-between align-items-center px-3'>
                  <h6 className='sidebarbuttontitle text-white m-0'>Layer Intersectrion  Builder</h6>
                  <button style={{
                    background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",

                    borderRadius: "4px", overflow: "auto"
                  }}
                    onClick={handleRefresh}
                  >Clear Data</button>
                </div>

                {/* <div className="tabs-container d-flex justify-content-between mt-3">

                  <button className={`tab-btn ${activeSelect === "area" ? "active" : ""}`} onClick={() => setActiveSelect("area")}>Select Area</button>
                
                </div> */}


                <div className={isToolHeight ? 'scroll-layerdiv' : 'scroll-layerdivheight '}>
                  {activeSelect === "area" ?
                    <>
                      <div>
                        {activeSelect === "area" ?
                          <>
                            <div
                              style={{
                                background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
                                height: "550px",
                                borderRadius: "4px", overflow: "auto"
                              }}>

                              <div style={{ marginLeft: "5px", marginTop: "2px" }}>
                                <Select
                                  options={districts.map((d) => ({ value: d.districtCode, label: d.districtName })).sort((a, b) => a.label.localeCompare(b.label))}
                                  value={districtCode ? { value: districtCode, label: selectedDistrict } : null}
                                  onChange={(selectedOption) => !selectedOption ? handleRefresh() : handleDistrictChange(selectedOption)}
                                  styles={customStyles} placeholder="Select District" isClearable={true} className="mt-3"
                                  isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User"}
                                />
                              </div>
                              <div style={{ marginLeft: "5px", marginTop: "12px" }}>
                                <Select
                                  options={ulbs.map((u) => ({ value: u.ulbCode, label: u.ulbName })).sort((a, b) => a.label.localeCompare(b.label))}
                                  value={ulbCode ? { value: ulbCode, label: selectedUlb } : null}
                                  onChange={handleUlbChange} placeholder="Select ULB" isClearable={true}
                                  isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User" || !districtCode} className="mt-3" styles={customStyles}
                                />

                              </div>
                              <div style={{ marginLeft: "5px", marginTop: "12px" }}>
                                <Select
                                  options={[{ value: "", label: "Ward - All" }, ...wardOptions]}
                                  value={
                                    wardCode
                                      ? { value: wardCode, label: selectedWard }
                                      : { value: "", label: "Ward - All" }
                                  }
                                  onChange={handleWardChange}
                                  placeholder="Select Ward"
                                  isClearable={true}
                                  styles={customStyles}
                                  isDisabled={!ulbCode}
                                />
                              </div>


                              <div id="DivQuery" style={{ backgroundColor: "#eaededff", marginTop: "12px", overflowY: "auto" }} >
                                <div style={{ backgroundColor: "#066853ff", color: "white", height: "10px" }}>

                                </div>
                                <div id="TargateLayer" style={{ height: "30%", marginTop: "5px", }}>

                                  <input style={{
                                    transform: "scale(1.6)",
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                    cursor: "pointer"
                                  }}
                                    type="checkbox"
                                    onChange={(e) => toggleWaterLayer(e.target.checked)}
                                  />
                                  <b> WATER Distribution Network </b>

                                </div>

                              </div>
                              <div id="DivQuery" style={{ backgroundColor: "#eaededff", marginTop: "12px", overflowY: "auto" }} >
                                <div id="TargateLayer" style={{ height: "20%", marginTop: "5px", }}>

                                  <input style={{
                                    transform: "scale(1.6)",
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                    cursor: "pointer",

                                  }}
                                    type="checkbox"
                                    onChange={(e) => toggleSewerLayer(e.target.checked)}
                                  />
                                  <b> SEWER Line </b>

                                </div>

                              </div>
                              <div style={{ backgroundColor: "#066853ff", color: "white", marginTop: "10px", height: "10px" }}>


                              </div>
                              <center>

                                {selectedWard && (
                                  <button
                                    style={{ backgroundColor: "rgb(16, 81, 86)", color: "white", marginTop: "10px", }}
                                    onClick={() => {
                                      setOpenDiv("div2")
                                      handleQuerySubmit(ulbCode, wardCode, districtCode);
                                    }}
                                  >
                                    View Details
                                  </button>
                                )}
                              </center>
                            </div>
                          </>
                          :
                          activeSelect === "propertyinfo" ?
                            <>
                              {/* {Bhupen Propertytab} */}

                              <div className={'scroll-layerdiv'} style={{ height: "600px" }} >
                                Table DATA
                              </div>
                            </>
                            :
                            <div className='col-lg-12 col-md-12 p-lg-8 px-3 '>
                              <div className={'scroll-layerdiv'} style={{ height: "600px" }} >
                                <LayerPanelPage view={view} />
                              </div>
                            </div>
                        }
                      </div>

                    </>
                    :
                    <LayerControlPanel />

                  }
                  {/* {!(authData?.UserType === "districtuser" || authData?.UserType === "User") &&
                    <button className="btn-refresh2" onClick={handleRefresh} style={{ marginTop: "14px" }}>
                      <img src={isTheme === 'light' ? "img/refreshlight.svg" : "img/refresh.svg"} alt="refresh" width="20px" height="20px" /> Refresh
                    </button>

                  } */}


                </div>
              </div>

              {/* // Bottom  css code for Card Details */}
              <div
                style={{
                  background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
                  borderRadius: "4px", overflow: "auto", marginLeft: "10px"
                }}>

                <div style={cardStyle}>
                  {/* Screws */}
                  <div style={{ ...screwStyle, top: "8px", left: "8px" }}>
                    <div style={screwLine}></div>
                  </div>
                  <div style={{ ...screwStyle, top: "8px", right: "8px" }}>
                    <div style={screwLine}></div>
                  </div>
                  <div style={{ ...screwStyle, bottom: "8px", left: "8px" }}>
                    <div style={screwLine}></div>
                  </div>
                  <div style={{ ...screwStyle, bottom: "8px", right: "8px" }}>
                    <div style={screwLine}></div>
                  </div>

                  <div className=' linear-gradian-bg align-items-center px-3'>
                    <center>
                      <h6 className='sidebarbuttontitle text-white m-0'>Intersection Summary</h6>
                    </center>

                  </div>

                  {(selectedDistrict || selectedUlb || selectedWard) ? (
                    <>
                      {selectedDistrict && (
                        <div style={cardRow}>
                          <span style={labelStyle}>District Name:</span>
                          <span style={valueStyle}>{selectedDistrict}</span>
                        </div>
                      )}

                      {selectedUlb && (
                        <div style={cardRow}>
                          <span style={labelStyle}>ULB Name:</span>
                          <span style={valueStyle}>{selectedUlb}</span>
                        </div>
                      )}

                      {selectedWard && (
                        <div style={cardRow}>
                          <span style={labelStyle}>Ward Name:</span>
                          <span style={valueStyle}>{selectedWard}</span>
                        </div>
                      )}
                    </>
                  ) : (
                    <center>
                      <div style={cardHeader}>Madhya Pradesh</div>
                      <span>Total ULB: {totalULB}</span>
                    </center>
                  )}


                  <div style={divider}></div>

                  <div style={countBox}>
                    <div style={cardHeader}>Intersection Points</div>
                    <div style={countValue}>{totalCount}</div>
                  </div>
                </div>
              </div>
              {/* // Bottom  css code for Card Details */}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
export default QueryAnalysis


